module.exports = "/_next/static/images/b73941fa4468aa478b325a787029678b-two-people-looking-xs@2x.jpg.webp";